import moment from "moment";
import { TwelveDataStockTimeSeries } from "../reducers/stocks/types";
import { FormattedStockData } from "./formatData";
import { calculateNetDiff } from "./calculateNetDiff";

const createGradient = (canvas: HTMLCanvasElement) => {
  const ctx = canvas.getContext("2d");
  const gradient = ctx?.createLinearGradient(0, 0, 100, 100);
  return { ctx, gradient };
};

type GraphData = {
  labels: moment.Moment[];
  datasets: Array<{
    label: string;
    backgroundColor?: CanvasGradient;
    borderColor: string;
    tension: number;
    data: string[];
  }>;
};

type GraphOptions = {
  elements: { point: { radius: number } };
  tooltips: { mode: string };
  scales: {
    xAxes: Array<{
      type: string;
      distribution: string;
      source: string;
      gridLines: { color: string };
      display: boolean;
      ticks: { display: boolean };
    }>;
    yAxes: Array<{
      display: boolean;
      gridLines: { color: string; drawBorder: boolean };
    }>;
  };
  maintainAspectRatio: boolean;
  responsive: boolean;
  title: { display: boolean };
  legend: { display: boolean };
};

// should separate logic for api and websocket

export const configureGraph = (
  canvas: HTMLCanvasElement,
  formatData: (stock: TwelveDataStockTimeSeries) => FormattedStockData,
  stock: TwelveDataStockTimeSeries
): { data: GraphData; options: GraphOptions } => {
  const { open, time } = formatData(stock);
  const { gradient } = createGradient(canvas);
  const oldest = parseFloat(stock.values[stock.values.length - 1].open);
  const latest = parseFloat(stock.values[0].open);
  const net = calculateNetDiff(latest, oldest);
  const data = {
    labels: time,
    datasets: [
      {
        label: stock.meta.symbol,
        backgroundColor: gradient,
        borderColor:
          parseFloat(net) < 0 ? "rgb(255,80,0)" : "rgb(0,250,154)",
        tension: 0.1,
        data: open,
      },
    ],
  };
  const options = {
    elements: {
      point: {
        radius: 0,
      },
    },
    tooltips: {
      mode: "x-axis",
    },
    scales: {
      xAxes: [
        {
          type: "time",
          distribution: "data",
          source: "data",
          gridLines: { color: "#fff" },
          display: false,
          ticks: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          display: false,
          gridLines: {
            color: "#fff",
            drawBorder: false,
          },
        },
      ],
    },
    maintainAspectRatio: false,
    responsive: true,
    title: {
      display: true,
    },
    legend: {
      display: false,
    },
  };
  return { data, options };
};
